import { useTranslation } from "react-i18next";

/** Datum und Uhrzeit in der Sprache der Oberfläche; ungültige oder fehlende Werte ergeben keine Ausgabe. */
export default function DateLabel({ value }) {
  const { i18n } = useTranslation();
  if (!value || !Number.isFinite(new Date(value).getTime())) return null;
  return <time dateTime={value}>{new Date(value).toLocaleString(i18n.language.startsWith("en") ? "en-GB" : "de-DE", {
    day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit",
  })}</time>;
}
